<template>
  <div>
    <div class="container flash-message-top-container">
      <flash-message class="flash-message-top"></flash-message>
    </div>    
    <div class="container container-admin text-center">
      
      <h3>{{title}}</h3>
      <div class="form-group row">        
        <div class="col-md-6 label-left">
           <Language />  
        </div>
        <div class="col-md-6 label-left">
            <label class="" for="commentPlace">Place on page</label>
            <select v-model="comment.place" class="form-control" id="commentPlace" name="commentPlace" aria-describedby="commentPlace">
              <option disabled value="">Please select one</option>
              <option value="1">Home slider</option>
              <option value="2">Comment page</option>
            </select>
        </div>    
      </div>    
        <div class="form-group row">
          <div class="col-md-12 label-left">
            <label class="requered" for="title">Title</label>
            <input type="text" class="form-control" v-bind:class="comment.language" id="title" v-validate="'required'" name="title" aria-describedby="categoryTitle" placeholder="Category Title" v-model="comment.title">    
            <span class="span-valid-text" v-show="errors.has('title')" >{{ errors.first('title') }} </span>
          </div>
        </div>
         <div class="form-group row">             
          <div class="col-md-12 label-left">
              <label for="txtCategoryDescription">Description</label>
              <HtmlEditor />    
          </div>
        </div>     
        <div class="form-group row">
         <div class="col-md-6 label-left">
            <label class="" for="title">Image Title</label>
            <input type="text" class="form-control" id="imageTitle"  name="imageTitle" aria-describedby="imageTitle" placeholder="Image Title" v-model="comment.image_title">
         </div>
         <div class="col-md-6 label-left">
            <label class="" for="image">Image</label>
            <input type="file" accept="image/*" class="form-control" id="image"  name="image" aria-describedby="imagePath" placeholder="Image Path"  @change="onChangeFile($event)">
         </div>
    </div>
        <button type="bottom" class="btn btn-primary" @click="(e) => saveComment(e)">Save Comment</button>
      </div>
    </div>
</template>

<script>

import HtmlEditor from "../../partial/HtmlEditor"
import Language from "../../partial/Language"
import { getDataFromServerWithHeader } from "../../../utils/DataProvider";

  export default {
    data: () => {
      return{
         title: 'Comment New',
         comment: {title: '', description: '', image: '', image_title: '', language: '', place:''},                 
      }     
    },
    components: {
       HtmlEditor,
       Language, 
    },
    methods: {
        changeLanguage(e){
          this.comment.language = e.target.value
        },

        onChangeFile(e){            
            this.image = event.target.files[0]
        },

        saveComment(e){
            e.preventDefault(); 
            
          this.$validator.validateAll().then((result) => {
            if(result){
              this.comment.description = this.$store.getters.COMMENT_DESCRIPTION;
              let data = new FormData();
              
              data.append('comment', JSON.stringify(this.comment));
              data.append('picture', this.image);  
              
              getDataFromServerWithHeader('add_comment', data, { 'Content-Type': 'multipart/form-data' })         
              .then(data => 
              {                
                this.flash('Saved comment success', 'success', {timeout: 4000})
                this.$router.push('/admin_comments')
              })
              .catch(err => {
                console.log("response : ", err);
                this.flash('Saved comment error: ' + err, 'error', {timeout: 4000})
              })             
            }
            else{
              this.flash('mandatory fields not filled ', 'error', {timeout: 4000})
            }
          })          
        },        
    },
    created() {      
      var htmlEditorObj = {
        textAction: 'SET_COMMENT_DESCRIPTION', 
        imageAction: '', 
        imageSaveCallBack: '', 
        text: 'comment description',
        image: ''}
      this.$store.dispatch('INIT_HTML_EDITOR', htmlEditorObj);

      //init language
      var languageObj = {
        name: 'language', 
        label: 'Language',
        selected: this.$store.getters.CURRENT_LANGUAGE,
        onSelectCB: this.changeLanguage, 
      }              
      this.$store.dispatch('INIT_LANGUAGE_ENTITY', languageObj);      
      this.comment.language = this.$store.getters.CURRENT_LANGUAGE
    }   
  }
</script>

<style scoped>
.he_IL{direction: rtl;}
  .ru_RU{direction: ltr;}
</style>
